import React from 'react'
import LoadingBar from './Notification/LoadingBar'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import { changeColorMode } from '../helpers/helpers'
import { CurrenTimeSpan, TimeSeparator } from './Header.styles'
import { DEPARTURE } from '../constants'
import { format } from 'date-fns'

import {
  DepartureWrapper,
  HeaderContainer,
  TimeWrapper,
  Title,
} from './HeaderSplit.styles'

function SplitPassagesHeader({ currentTime, showTime, stopName }) {
  const queryParam = queryString.parse(window.location.search)
  const lightMode = changeColorMode(queryParam.inverse)
  const minutes = format(currentTime, 'HH')
  const secondes = format(currentTime, 'mm')

  return (
    <>
      <HeaderContainer light={lightMode} data-testid="split-header">
        <TimeWrapper>
          {showTime && !!currentTime && (
            <CurrenTimeSpan light={lightMode} data-testid="split-time-span">
              {minutes}
              <TimeSeparator>:</TimeSeparator>
              {secondes}
            </CurrenTimeSpan>
          )}
        </TimeWrapper>
        <Title light={lightMode}>
          <h1>{stopName}</h1>
        </Title>
        <DepartureWrapper
          light={lightMode}
          className="header-departure"
          data-testid="split-departure-title"
        >
          {DEPARTURE}
        </DepartureWrapper>
      </HeaderContainer>
      <LoadingBar id="passage-loading-bar" lightMode={lightMode} isIrtis />
    </>
  )
}

SplitPassagesHeader.propTypes = {
  currentTime: PropTypes.number,
  showTime: PropTypes.bool,
  stopName: PropTypes.string,
}

export default SplitPassagesHeader
